import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import * as API from "../services/API";
import { Modal, Button } from "react-bootstrap";
import Footer from "../components/Footer";
import ErrorModal from "../components/ErrorModal";
import ConfirmModal from "../components/ConfirmModal";
import SuccessToast from "../components/SuccessToast";
import "../css/CARepository.css"
const AddCADocumentModal = ({ onClose, onAdd }) => {
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
	const onUploadFiles = (e) => {
		const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => setFile(reader.result);
        reader.readAsDataURL(file);
	}

  return (
    <Modal show={true} onHide={onClose} size="lg" backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Ajouter un document CA</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <label htmlFor="docName">Nom du document</label>
        <input
          type="text"
          className="form-control m-2"
          id="docName"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <div className="mb-3">
          <label htmlFor="formFile" className="form-label">
            Choisir un fichier PDF
          </label>
          <input
            className="form-control"
            type="file"
            id="formFile"
            accept="application/pdf"
            onChange={(e) => onUploadFiles(e)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Annuler
        </Button>
        <Button
          variant="primary"
          onClick={() => onAdd({ name, file })}
          disabled={!name.trim() || !file}
        >
          Ajouter
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

function CARepositoryAdmin() {
  const [documents, setDocuments] = useState([]);
  const [modalOpen, setModalOpen] = useState(null);
  const [error, setError] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [success, setSuccess] = useState(null);

  // Récupération documents
  useEffect(() => {
    API.getCADocuments(
      (res) => {console.log(res.data);setDocuments(res.data.data)},
      (err) => console.error(err)
    );
  }, []);

  const closeModal = () => setModalOpen(null);

  const openAddModal = () => setModalOpen(
    <AddCADocumentModal
      onClose={closeModal}
      onAdd={({ name, file }) => {
        API.uploadCADocument({ name, file },
          () => {
            API.getCADocuments(
              (updated) => setDocuments(updated.data.data),
              () => {}
            );
            setSuccess("Document ajoute avec succes.");
            closeModal();
          },
          (err) => setError(err)
        );
      }}
    />
  );
    const downloadPDF = (doc) => {
        const link = document.createElement("a");
        link.href = doc.file; // base64 complet déjà formaté
        link.download = `${doc.name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const confirmDelete = (doc) => {
        setConfirm({
            title: "Supprimer le document ?",
            message: `Le document "${doc.name}" sera définitivement supprimé.`,
            onConfirm: () => {
            API.deleteCADocument(
                doc.fileId,
                () => {
                API.getCADocuments(
                    (updated) => setDocuments(updated.data.data),
                    () => {}
                );
                setConfirm(null);
                },
                (err) => {
                setError(err);
                setConfirm(null);
                }
            );
            }
        });
    };

  return (
    <>
      <HeaderHomeAdmin />

      <div className="ca-repo-container">
        <h1 className="text-center m-5">Gestion des comptes rendus de CA</h1>

        <button className="btn btn-dark m-3" onClick={openAddModal}>
          Ajouter un document
        </button>

        {documents.length === 0 ? (
        <div className="document-empty">
            📂 Aucun document disponible pour le moment.
        </div>
        ) : (
        <div className="pdf-grid">
            {documents.map((doc, index) => (
            <div key={index} className="pdf-card">

                <div className="pdf-icon">
                📄
                </div>

                <div className="pdf-info">
                <div className="pdf-title">
                    {doc.name}
                </div>

                <div className="pdf-actions">
                    <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => downloadPDF(doc)}
                    >
                    Télécharger
                    </button>

                    <button
                    className="btn btn-danger btn-sm"
                    onClick={() => confirmDelete(doc)}
                    >
                    Supprimer
                    </button>
                </div>
                </div>

            </div>
            ))}
        </div>
        )}

      </div>

      <ConfirmModal
        show={!!confirm}
        title={confirm?.title}
        message={confirm?.message}
        onConfirm={confirm?.onConfirm}
        onClose={() => setConfirm(null)}
      />

      <ErrorModal
        show={!!error}
        message={error}
        onClose={() => setError(null)}
      />
      <SuccessToast
        show={!!success}
        message={success}
        onClose={() => setSuccess(null)}
      />

      {modalOpen}

      <Footer />
    </>
  );
}

export default CARepositoryAdmin;
